import { ScreenshotClocks } from '@shared';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ApiAudit } from 'App';

export function useScreenshotClocks(
  streamHandle: string | undefined
): UseQueryResult<ScreenshotClocks> {
  return useQuery(
    ['screenshot clocks', streamHandle],
    () => ApiAudit.getScreenshotClocks(streamHandle),
    {
      enabled: Boolean(streamHandle),
      select: (data) => data?.screenshotClocks || [],
    }
  );
}
